class g {
  /**
   * Get a specific query parameter value
   * @param key - The query parameter key to retrieve
   * @returns The parsed value of the query parameter or null if not found
   */
  get(e) {
    const n = new URLSearchParams(window.location.search).get(e);
    if (n === null)
      return null;
    if (n.startsWith("[") || n.startsWith("{"))
      try {
        return JSON.parse(n);
      } catch {
        return n;
      }
    return n;
  }
  /**
   * Set a single query parameter
   * @param key - The query parameter key to set
   * @param value - The value to set (can be string, number, boolean, or array)
   */
  set(e, t) {
    const n = new URLSearchParams(window.location.search);
    Array.isArray(t) || typeof t == "object" ? n.set(e, JSON.stringify(t)) : n.set(e, String(t)), this.updateUrl(n);
  }
  /**
   * Set multiple query parameters at once
   * @param paramsObject - Object containing key-value pairs to set
   */
  setMany(e) {
    const t = new URLSearchParams(window.location.search);
    for (const [n, s] of Object.entries(e))
      Array.isArray(s) || typeof s == "object" ? t.set(n, JSON.stringify(s)) : t.set(n, String(s));
    this.updateUrl(t);
  }
  /**
   * Get all query parameters as an object
   * @returns Object containing all query parameters with values parsed when possible
   */
  getAll() {
    const e = new URLSearchParams(window.location.search), t = {};
    return e.forEach((n, s) => {
      if (n.startsWith("[") || n.startsWith("{"))
        try {
          t[s] = JSON.parse(n);
        } catch {
          t[s] = n;
        }
      else
        t[s] = n;
    }), t;
  }
  /**
   * Delete a specific query parameter
   * @param key - The query parameter key to delete
   */
  delete(e) {
    const t = new URLSearchParams(window.location.search);
    t.delete(e), this.updateUrl(t);
  }
  /**
   * Reset all query parameters (remove all)
   */
  reset() {
    this.updateUrl(new URLSearchParams());
  }
  /**
   * Update the URL with new query parameters without page reload
   * @private
   * @param params - URLSearchParams object with the new parameters
   */
  updateUrl(e) {
    const t = e.toString() ? `${window.location.pathname}?${e.toString()}` : window.location.pathname;
    window.history.pushState({}, "", t);
  }
  setSelectedOptions(e, t) {
    const n = this.get(`option_${e}`);
    n && Array.isArray(n) ? this.set(`option_${e}`, [...n, ...t]) : this.set(`option_${e}`, t);
  }
  removeSelectedOption(e, t) {
    const n = this.get(`option_${e}`);
    n && Array.isArray(n) && this.set(
      `option_${e}`,
      n.filter((s) => !t.includes(String(s)))
    );
  }
  decrementSelectedOption(e, t) {
    const n = this.get(`option_${e}`);
    if (n && Array.isArray(n)) {
      const s = n.indexOf(t);
      s > -1 && n.splice(s, 1), this.set(`option_${e}`, n);
    }
  }
  getSelectedOptions(e) {
    return this.get(`option_${e}`);
  }
  getAllSelectedOptions() {
    const e = this.getAll(), t = Object.keys(e).filter(
      (s) => s.startsWith("option_")
    ), n = {};
    for (const s of t)
      n[s.replace("option_", "")] = e[s];
    return n;
  }
  removeSelectedOptionKey(e) {
    this.delete(`option_${e}`);
  }
  setSellingPlan(e, t) {
    this.set(`selling_plan_option_${e}`, t);
  }
  getSellingPlan(e) {
    return this.get(`selling_plan_option_${e}`);
  }
  removeSellingPlan(e) {
    this.delete(`selling_plan_option_${e}`);
  }
}
const r = new g();
class a {
  constructor() {
    this.observers = /* @__PURE__ */ new Set(), this.handleNavigation = () => {
      this.notifyObservers();
    }, window.addEventListener("popstate", this.handleNavigation);
    const e = window.history.pushState, t = window.history.replaceState;
    window.history.pushState = (...n) => {
      e.apply(window.history, n), this.handleNavigation();
    }, window.history.replaceState = (...n) => {
      t.apply(window.history, n), this.handleNavigation();
    }, window.addEventListener("hashchange", this.handleNavigation);
  }
  static getInstance() {
    return a.instance || (a.instance = new a()), a.instance;
  }
  subscribe(e) {
    return this.observers.add(e), () => this.observers.delete(e);
  }
  notifyObservers() {
    this.observers.forEach((e) => e());
  }
  getAllSelectedOptions() {
    return r.getAllSelectedOptions();
  }
  setSelectedOptions(e, t) {
    r.setSelectedOptions(e, t);
  }
  removeSelectedOption(e, t) {
    r.removeSelectedOption(e, t);
  }
  removeSelectedOptionKey(e) {
    r.removeSelectedOptionKey(e);
  }
  getSellingPlan(e) {
    return r.getSellingPlan(e);
  }
  setSellingPlan(e, t) {
    r.setSellingPlan(e, t);
  }
  removeSellingPlan(e) {
    r.removeSellingPlan(e);
  }
  reset() {
    r.reset();
  }
  get(e) {
    return r.get(e);
  }
}
const d = a.getInstance();
function u() {
  var e, t;
  const i = (t = (e = window.Shopify) == null ? void 0 : e.routes) == null ? void 0 : t.root;
  return i.endsWith("/") ? i : `${i}/`;
}
const S = (i, e) => i.includes("?") ? `${i}&${new URLSearchParams(e).toString()}` : `${i}?${new URLSearchParams(e).toString()}`, w = "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image.png";
function f(i, { width: e, height: t } = {}) {
  const n = i || w, s = {};
  return e && (s.width = e.toString()), t && (s.height = t.toString()), S(n, s);
}
const y = (i) => {
  var t;
  let e = "${{amount}}";
  return (t = window == null ? void 0 : window.LOR) != null && t.moneyFormat && (e = window.LOR.moneyFormat), e.replace("{{amount}}", (i / 100).toFixed(2));
}, m = (i, e) => Object.keys(i).flatMap((t) => {
  const n = i[t].map((o) => e[o]), s = d.getSellingPlan(t);
  return s ? n.map((o) => {
    var c, p;
    const l = (c = o == null ? void 0 : o.selling_plan_allocations) == null ? void 0 : c.find(
      (h) => h.selling_plan_id === Number(s)
    );
    return l != null && l.price ? l.price : ((p = ((o == null ? void 0 : o.selling_plan_allocations) || [])[0]) == null ? void 0 : p.price) || (o == null ? void 0 : o.price) || 0;
  }) : n.map((o) => (o == null ? void 0 : o.price) || 0);
}).reduce((t, n) => t + n, 0);
function O(i, e) {
  return i.replace(/#([^#]+)#/g, (t, n) => {
    const s = n.trim();
    return e.hasOwnProperty(s) ? e[s] : t;
  });
}
const _ = (i, e, t) => {
  const n = t.sort((s, o) => o.tier.condition_quantity_gte - s.tier.condition_quantity_gte).find((s) => s.tier.condition_quantity_gte <= e);
  return n ? i * (100 - parseInt(n.tier.discount_value)) / 100 : i;
};
export {
  m as a,
  _ as b,
  d as c,
  u as d,
  y as f,
  f as g,
  O as p,
  r as q
};
